<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2325_8844)">
      <rect width="24" height="24" rx="12" fill="#29292F" />
      <circle cx="11.9996" cy="9.0001" r="5.4" fill="#FCC1C8" />
      <rect x="10.6533" y="13.9977" width="2.69311" height="2.81761" fill="#FCC1C8" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.287 7.89848C15.6681 8.60699 13.8797 9.0001 11.9995 9.0001C10.1193 9.0001 8.33082 8.60697 6.71191 7.89842C7.22059 5.44441 9.39464 3.6001 11.9994 3.6001C14.6043 3.6001 16.7783 5.44444 17.287 7.89848Z" fill="black" />
      <circle cx="12" cy="31.2001" r="15" fill="#00BE90" />
    </g>
    <defs>
      <clipPath id="clip0_2325_8844">
        <rect width="24" height="24" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
